import accessLocalStorage from './accessLocalStorage';
import axios from 'axios';

// === DRY: Factory for API requests ===

async function fail2banRequest(method, endpoint, data = null) {
  const { token, ipRequest } = accessLocalStorage.getUserLocalStorage();
  const config = { headers: { Authorization: token } };
  const url = `${ipRequest}api/security/fail2ban/${endpoint}`;

  switch (method) {
    case 'get':
      return (await axios.get(url, config)).data;
    case 'post':
      return (await axios.post(url, data, config)).data;
    case 'delete':
      return (await axios.delete(url, config)).data;
    default:
      throw new Error(`Metodo HTTP nao suportado: ${method}`);
  }
}

// === System-level (root only) ===

export const getFail2banStatus = () => fail2banRequest('get', '');

export const getBannedIPs = () => fail2banRequest('get', 'banned');

export const banIP = (jail, ip) => fail2banRequest('post', 'ban', { jail, ip });

export const unbanIP = (jail, ip) => fail2banRequest('post', 'unban', { jail, ip });

export const getWhitelist = () => fail2banRequest('get', 'whitelist');

export const addToWhitelist = (ip) => fail2banRequest('post', 'whitelist', { ip });

export const removeFromWhitelist = (ip) => fail2banRequest('post', 'whitelist/remove', { ip });

// === Tenant-level (self-service) ===

export const getMyIP = () => fail2banRequest('get', 'my-ip');

export const getTenantWhitelist = (tenant) => fail2banRequest('get', `tenant/${tenant}/whitelist`);

export const addTenantAddress = (tenant, address, reason) =>
  fail2banRequest('post', `tenant/${tenant}/whitelist`, { address, reason });

export const removeTenantAddress = (tenant, id) =>
  fail2banRequest('delete', `tenant/${tenant}/whitelist/${id}`);
